function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { posToDOMRect, Extension } from '@tiptap/core';
import { PluginKey, Plugin } from 'prosemirror-state';
import tippy from 'tippy.js';

var BubbleMenuView = /*#__PURE__*/function () {
  function BubbleMenuView(_ref) {
    var _this = this;

    var editor = _ref.editor,
        element = _ref.element,
        view = _ref.view,
        tippyOptions = _ref.tippyOptions;

    _classCallCheck(this, BubbleMenuView);

    this.preventHide = false;

    this.mousedownHandler = function () {
      _this.preventHide = true;
    };

    this.focusHandler = function () {
      // we use `setTimeout` to make sure `selection` is already updated
      setTimeout(function () {
        return _this.update(_this.editor.view);
      });
    };

    this.blurHandler = function (_ref2) {
      var event = _ref2.event;

      var _a;

      if (_this.preventHide) {
        _this.preventHide = false;
        return;
      }

      if ((event === null || event === void 0 ? void 0 : event.relatedTarget) && ((_a = _this.element.parentNode) === null || _a === void 0 ? void 0 : _a.contains(event.relatedTarget))) {
        return;
      }

      _this.hide();
    };

    this.editor = editor;
    this.element = element;
    this.view = view;
    this.element.addEventListener('mousedown', this.mousedownHandler, {
      capture: true
    });
    this.editor.on('focus', this.focusHandler);
    this.editor.on('blur', this.blurHandler);
    this.createTooltip(tippyOptions);
    this.element.style.visibility = 'visible';
  }

  _createClass(BubbleMenuView, [{
    key: "createTooltip",
    value: function createTooltip() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.tippy = tippy(this.view.dom, _objectSpread({
        duration: 0,
        getReferenceClientRect: null,
        content: this.element,
        interactive: true,
        trigger: 'manual',
        placement: 'top',
        hideOnClick: 'toggle'
      }, options));
    }
  }, {
    key: "update",
    value: function update(view, oldState) {
      var state = view.state,
          composing = view.composing;
      var doc = state.doc,
          selection = state.selection;
      var isSame = oldState && oldState.doc.eq(doc) && oldState.selection.eq(selection);

      if (composing || isSame) {
        return;
      }

      var from = selection.from,
          to = selection.to,
          empty = selection.empty;

      if (empty) {
        this.hide();
        return;
      }

      this.tippy.setProps({
        getReferenceClientRect: function getReferenceClientRect() {
          return posToDOMRect(view, from, to);
        }
      });
      this.show();
    }
  }, {
    key: "show",
    value: function show() {
      this.tippy.show();
    }
  }, {
    key: "hide",
    value: function hide() {
      this.tippy.hide();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.tippy.destroy();
      this.element.removeEventListener('mousedown', this.mousedownHandler);
      this.editor.off('focus', this.focusHandler);
      this.editor.off('blur', this.blurHandler);
    }
  }]);

  return BubbleMenuView;
}();

var BubbleMenuPluginKey = new PluginKey('menuBubble');

var BubbleMenuPlugin = function BubbleMenuPlugin(options) {
  return new Plugin({
    key: BubbleMenuPluginKey,
    view: function view(_view) {
      return new BubbleMenuView(_objectSpread({
        view: _view
      }, options));
    }
  });
};

var BubbleMenu = Extension.create({
  name: 'bubbleMenu',
  defaultOptions: {
    element: null,
    tippyOptions: {}
  },
  addProseMirrorPlugins: function addProseMirrorPlugins() {
    if (!this.options.element) {
      return [];
    }

    return [BubbleMenuPlugin({
      editor: this.editor,
      element: this.options.element,
      tippyOptions: this.options.tippyOptions
    })];
  }
});
export default BubbleMenu;
export { BubbleMenu, BubbleMenuPlugin, BubbleMenuPluginKey, BubbleMenuView };